import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { MailRecordEntity } from './mail-record.entity';

@Index('_fk__mail_record__id', ['fkMailRecordId'], {})
@Entity('_mail_recipient')
export class MailRecipientEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__mail_record__id',
		nullable: true,
		unsigned: true,
	})
	public fkMailRecordId!: number | null;

	@Column('varchar', { name: '_email', length: 191 })
	public email!: string;

	@Column('varchar', { name: '_type', length: 10 })
	public type!: string;

	@ManyToOne(
		() => MailRecordEntity,
		(mailRecord) => mailRecord.mailRecipients,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__mail_record__id', referencedColumnName: 'id' }])
	public fkMailRecord!: MailRecordEntity;
}
